/** The rail's name for the page of the organisation's shared assets. */
export function sharedAssetsLabel(hasSelfServeAccess: boolean) {
  return hasSelfServeAccess ? 'Shared assets' : 'Manage access';
}

/**
 * The name of the account's functions view. For a customer it holds their API token, so a self-serve
 * customer sees that; the team's view also holds the internal sections and everyone else keeps the
 * name they had.
 */
export function functionsViewLabel(isTeam: boolean, hasSelfServeAccess: boolean) {
  return hasSelfServeAccess && !isTeam ? 'API access' : 'Administration';
}
